import React from 'react'
import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { formatAddressToExtended } from '../../../../utils'

export type TakeAwayPackageAddressProps = {
  pickupStoreInfo: PickupStoreInfo | null | undefined
}

export const TakeAwayPackageAddress = ({
  pickupStoreInfo,
}: TakeAwayPackageAddressProps) => {
  return (
    <>
      <Text variant="title1" tone="secondary">
        <FormattedMessage id="checkout.order-summary.products-pickup.takeaway-store-title" />
      </Text>
      <Text variant="title1" aria-label="pickup-store">
        {`${pickupStoreInfo?.friendlyName} `}
        {formatAddressToExtended({
          city: pickupStoreInfo?.address?.city,
          number: pickupStoreInfo?.address?.number,
          postalCode: pickupStoreInfo?.address?.postalCode ?? '',
          state: pickupStoreInfo?.address?.state,
          street: pickupStoreInfo?.address?.street,
          complement: pickupStoreInfo?.address?.complement ?? '',
        })}
      </Text>
    </>
  )
}
